export enum adminApplicantsDeleteTypes {
    FETCH_ADMIN_APPLICANTS_DELETE_REQUEST = "FETCH_ADMIN_APPLICANTS_DELETE_REQUEST",
    FETCH_ADMIN_APPLICANTS_DELETE_SUCCESS = "FETCH_ADMIN_APPLICANTS_DELETE_SUCCESS",
    FETCH_ADMIN_APPLICANTS_DELETE_FAILURE = "FETCH_ADMIN_APPLICANTS_DELETE_FAILURE",
  }